import React from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';

// Components
import Reset from './Reset';

// Types
import { INewPasswordFields } from '../Login/types';

// Constants
import { breakpoints } from 'Constants';
import { resetUserPassword } from '../../actions';
import { selector } from './selector';

const ConnectedReset = () => {
  const { pending, error } = useSelector(selector);
  const dispatch = useDispatch();

  const handleReset = (fields: INewPasswordFields): void => {
    dispatch(resetUserPassword(fields));
  };

  return (
    <Wrapper>
      <Reset onSubmit={handleReset} pending={pending} error={error} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: calc(100vh - 72px);
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: ${breakpoints.medium}px) {
    display: block;
  }
`;

export default ConnectedReset;
